import { makeObservable, observable, action } from 'mobx';
import { dataAccess } from 'ts/core/dataAccess/dataAccess';

export interface ICommitter {
  id: number;
  author: string;
  email: string;
}

export interface IContributor {
  id: string;
  name: string;
  committers: ICommitter[];
  added_on: string;
  group: string;
}

export interface IContributorUpdate {
  name?: string;
  group?: string;
}

export interface ITogglUser {
  id: any;
  name: any;
}

export interface IContributorsStore {
  contributorsList: IContributor[];
  togglUserList: ITogglUser[];
  setContributorsList: () => void;
  setTogglUserList: () => void;
  editContributor: (id: string, { name, group }: IContributorUpdate) => void;
  mergeContributors: (sourceId: string, targetId: string) => void;
  detachCommiter: (id: number) => void;
  attachCommiterToContributor: (committerId: number, contributorId: string) => void;
}

class ContributorsStore implements IContributorsStore {
  contributorsList: IContributor[] = [];
  togglUserList: ITogglUser[] = [];
  constructor() {
    makeObservable(this, {
      togglUserList: observable,
      contributorsList: observable,
      setContributorsList: action,
      setTogglUserList: action,
    });
  }

  async setContributorsList() {
    const [contributorsList] = await dataAccess.getContributorsList();
    this.contributorsList = contributorsList ?? [];
  }

  async setTogglUserList() {
    const [togglUserList] = await dataAccess.getTogglUserList();
    this.togglUserList = togglUserList;
  }

  async editContributor(id: string, payload: IContributorUpdate) {
    await dataAccess.editContributor(id, payload);
  }

  async mergeContributors(sourceId: string, targetId: string) {
    await dataAccess.mergeContributors(sourceId, targetId);
  }

  async detachCommiter(id: number) {
    await dataAccess.detachCommiter(id);
  }

  async attachCommiterToContributor(committerId: number, contributorId: string) {
    await dataAccess.attachCommiterToContributor(String(committerId), contributorId);
  }
}

const contributorsStore = new ContributorsStore();

export default contributorsStore; 
